import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TopRibbon, { AdRail } from "@/components/TopRibbon";
import SponsoredStrip from "@/components/SponsoredStrip";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout() {
  const { pathname } = useLocation();
  const hideRails =
    pathname.startsWith("/chat") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/apps");

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ImpersonationBanner />
      <TopRibbon />
      <Header />
      <SponsoredStrip />
      <div className="flex-1 flex w-full">
        {!hideRails && (
          <div className="hidden xl:block w-[200px] shrink-0 px-3 pt-6">
            <AdRail side="left" />
          </div>
        )}
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
        {!hideRails && (
          <div className="hidden xl:block w-[200px] shrink-0 px-3 pt-6">
            <AdRail side="right" />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
